import React from 'react';
import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

const Test = () => (
  <div className="business-main-slider">
    <OwlCarousel className="owl-carousel main-slider" items={1} dots={false} loop autoplay margin={0}>
      <div className="item">
        <div className="hvrbox">
          <img src="/images/_bg/net-01.jpg" alt="Mountains" className="hvrbox-layer_bottom" />
          <div className="hvrbox-layer_top">
            <div className="container">
              <div className="overlay-text text-left">
                <h3 data-animation-in="slideInDown" data-animation-out="animate-out slideOutUp">
                  Construction Company
                </h3>
                <h2 data-animation-in="slideInDown" data-animation-out="animate-out slideOutUp">
                  We Build Big Things
                </h2>
                <p data-animation-in="slideInLeft" data-animation-out="animate-out fadeOut">
                  At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis <br /> praesentium
                  voluptatum deleniti atque corrupti quos dolores et <br />quas molestias excepturi sint occaecati
                </p>
                <a
                  href="#"
                  className="bussiness-btn-larg"
                  data-animation-in="slideInUp"
                  data-animation-out="animate-out slideOutDown"
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="item">
        <div className="hvrbox">
          <img src="/images/_bg/net-02.jpg" alt="Mountains" className="hvrbox-layer_bottom" />
          <div className="hvrbox-layer_top">
            <div className="container">
              <div className="overlay-text text-left">
                <h3 data-animation-in="slideInDown" data-animation-out="animate-out slideOutUp">
                  Construction Company
                </h3>
                <h2 data-animation-in="slideInDown" data-animation-out="animate-out slideOutUp">
                  We Build Big Things
                </h2>
                <p data-animation-in="slideInLeft" data-animation-out="animate-out fadeOut">
                  At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis <br /> praesentium
                  voluptatum deleniti atque corrupti quos dolores et <br />quas molestias excepturi sint occaecati
                </p>
                <a
                  href="#"
                  className="bussiness-btn-larg"
                  data-animation-in="slideInUp"
                  data-animation-out="animate-out slideOutDown"
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="item">
        <h4>3</h4>
      </div>
      <div className="item">
        <h4>4</h4>
      </div>
    </OwlCarousel>
  </div>
);

export default Test;



// WEBPACK FOOTER //
// ./src/components/Test.js